// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.nav-link a[data-v-81440b78] {\n  color: white;\n}\n.navbar[data-v-81440b78], a[data-v-81440b78] {\n  background-color: #150957 !important;\n}\n#nav[data-v-81440b78] {\n  padding: 30px;\n}\n#nav a[data-v-81440b78] {\n  font-weight: bold;\n  color: #2c3e50;\n}\n#nav a.router-link-exact-active[data-v-81440b78] {\n  color: #42b983;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
